// One line saying what a timer is set to, for rows like "Tabata  20 s / 10 s × 8".
// Shown in place of the preset's description, which said what the format is
// rather than what you'd get (#109).

const secs = (n) => {
  const v = Math.round(Number(n) || 0);
  if (v >= 60 && v % 60 === 0) return `${v / 60} min`;
  if (v > 60) return `${Math.floor(v / 60)}:${String(v % 60).padStart(2, "0")}`;
  return `${v} s`;
};

const withSets = (text, s) => ((s.sets ?? 1) > 1 ? `${text} × ${s.sets}` : text);

export const describeTimer = (mode, settings = {}) => {
  const s = settings || {};
  switch (mode) {
    case "tabata":
    case "hiit":
      return withSets(`${s.work ?? 0} s / ${s.rest ?? 0} s × ${s.rounds ?? 1}`, s);
    case "emom": {
      const every = s.duration ?? 60;
      return withSets(`${s.rounds ?? 1} × ${secs(every)}`, s);
    }
    case "amrap":
    case "countdown":
      return withSets(secs(s.duration ?? 0), s);
    case "fgb":
      return `${s.exercises ?? 0} × ${s.exerciseTime ?? 0} s × ${s.rounds ?? 1}`;
    case "circuit":
      return `${s.exercises ?? 0} × ${s.exerciseTime ?? 0} s / ${s.restTime ?? 0} s × ${s.rounds ?? 1}`;
    case "stopwatch":
      return "Counts up";
    case "free":
      return "No plan. Log what you do as you go";
    default:
      return "";
  }
};
